import { useState } from "react";
import { api } from "../lib/api";

/** RFQ cards and empty galleries share the text-only KontrataPH cover. */
export function RfqCover({ src, alt }: { src?: string | null; alt: string }) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const resolved = api.apiAssetUrl(src);
  if (resolved && resolved !== failedSrc) {
    return <img src={resolved} alt={alt} className="h-full w-full object-cover" loading="lazy" onError={() => setFailedSrc(resolved)} />;
  }
  return <div role="img" aria-label="KontrataPH default RFQ cover" style={{ containerType: "inline-size" }} className="grid h-full w-full place-items-center bg-gradient-to-br from-navy to-navy-600 text-white/90">
    <span className="text-[clamp(7px,5cqw,20px)] font-bold tracking-[0.15em]">KONTRATA<span className="text-brand-gold">PH</span></span>
  </div>;
}
